import { get, isObject } from 'lodash';

// Data that should be rendered for used inline component.
export const USED_ITEMS = [
  { title: '', value: 'summary' },
  { title: '', value: 'edmundsSays' },
  { title: '', value: 'introduction' },
  { title: '', value: 'review' },
  { title: '', value: 'trimFeaturesBodySnippet' },
  { title: '', value: 'body' },
  { title: '', value: 'trimFeaturesBody' },
  { title: '', value: 'trimTested' },
  { title: '', value: 'powertrain' },
  { title: '', value: 'safety' },
  { title: 'Driving', id: 'driving-section', value: 'driving', dataSet: 'ratings' },
  { title: 'Acceleration', id: '', value: 'acceleration', dataSet: 'ratings' },
  { title: 'Braking', id: '', value: 'brakes', dataSet: 'ratings' },
  { title: 'Steering', id: '', value: 'steering', dataSet: 'ratings' },
  { title: 'Handling', id: '', value: 'handling', dataSet: 'ratings' },
  { title: 'Drivability', id: '', value: 'drivability', dataSet: 'ratings' },
  { title: 'Comfort', id: 'comfort-section', value: 'comfort', dataSet: 'ratings' },
  { title: 'Seat comfort', id: '', value: 'seatComfort', dataSet: 'ratings' },
  { title: 'Ride comfort', id: '', value: 'rideComfort', dataSet: 'ratings' },
  { title: 'Noise & vibration', id: '', value: 'noiseVibration', dataSet: 'ratings' },
  { title: 'Climate control', id: '', value: 'climateControl', dataSet: 'ratings' },
  { title: 'Interior', id: 'interior-section', value: 'interior', dataSet: 'ratings' },
  { title: 'Ease of use', id: '', value: 'easeUse', dataSet: 'ratings' },
  { title: 'Getting in/getting out', id: '', value: 'gettingInOut', dataSet: 'ratings' },
  { title: 'Driving position', id: '', value: 'drivingPosition', dataSet: 'ratings' },
  { title: 'Roominess', id: '', value: 'roominess', dataSet: 'ratings' },
  { title: 'Visibility', id: '', value: 'visibility', dataSet: 'ratings' },
  { title: 'Quality', id: '', value: 'quality', dataSet: 'ratings' },
];

/**
 * Checks for existing content for used inline component data set.
 * @param {object} editorialReview.
 * @returns {bool}
 */
export function isUsedDataAvailable(editorialReview) {
  return (
    isObject(editorialReview) &&
    USED_ITEMS.some(({ dataSet, value }) => get(editorialReview, dataSet ? `${dataSet}.${value}` : value, false))
  );
}
